import { render } from "./DiagnosisDisplayStage.vue?vue&type=template&id=bb508d9c&scoped=true"
import script from "./DiagnosisDisplayStage.vue?vue&type=script&lang=js"
export * from "./DiagnosisDisplayStage.vue?vue&type=script&lang=js"

import "./DiagnosisDisplayStage.vue?vue&type=style&index=0&id=bb508d9c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb508d9c"]])

export default __exports__